<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div>
        <span style="font-size: 13px; color:#97a8be">聊天消息</span>
      </div>
    </div>

    <div style="padding: 10px 15px">
      <div style="overflow-x: scroll">
        <table width="100%">
          <tr>
            <th class="th">
              消息ID
            </th>
            <th class="th">
              发送人
            </th>
            <th class="th">
              接收人
            </th>
            <th class="th">
              消息类型
            </th>
            <th class="th">
              消息内容
            </th>
            <th class="th">
              状态
            </th>
            <th class="th">
              发送时间
            </th>
          </tr>
          <tr :key="index" v-for="(value,index) in adminList">
            <td class="td" style="width: 125px">
              {{ value.message_uuid }}
            </td>
            <td  class="td">
              {{ value.message_user }}
            </td>
            <td  class="td">
              {{ value.message_to_user }}
            </td>
            <td class="td">
              {{ value.message_type==0?"文字":
                value.message_type==1?"图片":
                    value.message_type==2?"视频":"红包/转账"}}
            </td>
            <td class="td">
              {{ value.message_txt }}
            </td>
            <td class="td">
              {{ value.message_state==0?'待送达':'已送达' }}
            </td>
            <td  class="td">
              {{ value.message_time }}
            </td>

          </tr>
        </table>
      </div>
      <div style="padding-top: 20px; font-size: 12px; color: #606266; text-align: right">
        一页显示 <input v-model="num" style="text-align: center; width: 30px; min-width: 30px;" class="text1"/>
        条，共<span v-html="count"></span>条数据
        <img src="@/assets/home/shuaxin.png" v-on:click="selectAdminList()" title="刷新"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shouye.png" v-on:click="currPage(1)" title="首页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shangyiye.png" v-on:click="currPage(2)" title="上一页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <input v-model="page" style="text-align: center; width: 30px; min-width: 30px;" class="text1"/> / <span
          v-html="countPage"></span>页
        <img src="@/assets/home/xiayiye.png" v-on:click="currPage(3)" title="下一页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/weiye.png" v-on:click="currPage(5)" title="尾页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shuaxin.png" v-on:click="selectAdminList()" title="刷新"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
      </div>
    </div>
  </div>
</template>

<script>

import {closeLoading, DO_NET_URL,RUST_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost} from "@/main";

export default {
  name: "friendMsg",
  data() {
    return {
      chanel: "",
      code: "",
      name: "",
      company: "",
      state: "",
      recommend: "",
      adminList: [],
      page: 1,
      num: 10,
      count: 0,
      countPage: 0,
      imgUrl: "",
      levelList: [],
      teamLevelList: []
    }
  },
  mounted() {
    let that = this
    if (localStorage.getItem("iwa_token") == null || localStorage.getItem("iwa_token") == "") {
      setTimeout(function () {
        that.$router.replace('index')
      }, 600);
    }
    axiosGet(DO_NET_URL + "api/GetLevel", function (res) {
      console.log(res.data)
      that.levelList = res.data
    })
    this.selectAdminList()
  },
  methods: {
    queryMsg(user1,user2){
      localStorage.setItem("msgKey",user1+"_"+user2)
      window.open("#/friendMsg")
    },
    getLevelName(id) {
      if (id == 1) {
        return "青铜起航";
      } else if (id == 2) {
        return "白银优选";
      } else if (id == 3) {
        return "黄金尊享";
      } else if (id == 4) {
        return "铂金臻选";
      } else if (id == 5) {
        return "钻石贵宾";
      } else if (id == 6) {
        return "黑曜私域";
      } else if (id == 7) {
        return "神龙世家";
      } else if (id == 8) {
        return "天凤至尊";
      } else if (id == 9) {
        return "超级天凤至尊";
      }
      return "普通";
    },
    deleteProject(id) {
      let that = this
      if (confirm("确认删除此项目？删除需谨慎，一旦删除将无法恢复，所产生的投资信息将无法正常发放！")) {
        axiosPost(DO_NET_URL + "project/DeleteProject?projectId=" + id, "", function (res) {
          console.log(res)
          if (res.code == 200) {
            toask("删除成功！", 6)
            that.selectAdminList()
          } else {
            toask(res.data, 6)
          }
        })
      }
    },
    updateSchedule(id, e) {
      if (e == "") {
        toask("进度不能为空！", 6)
        return
      }
      axiosPost(DO_NET_URL + "project/UpdateSchedule?projectId=" + id + "&projectSchedule=" + e, function (res) {

      })
      console.log(id)
      console.log(e)
    },
    addValue(code) {
      localStorage.setItem("userCode", code)
      this.$emit("send", "addValue")
    },
    breakProject(code) {
      localStorage.setItem("userCode", code)
      this.$emit("send", "breakProject")
    },
    childUser(code) {
      localStorage.setItem("userCode", code)
      this.$emit("send", "childUser")
    },
    updateAdmin(obj) {
      localStorage.setItem("UPDATEOBJ", JSON.stringify(obj))
      this.$emit("send", 'updateLevelOrder')
    },

    addAdmin() {
      this.$emit("send", 'addStock')
    },
    currPage(num) {
      if (num == 1) {
        this.page = 1
      } else if (num == 5) {
        this.page = this.countPage
      } else if (num == 2) {
        if (this.page > 1) {
          this.page -= 1
        }
      } else {
        if (this.page < this.countPage) {
          this.page += 1
        }
      }
      this.selectAdminList()
    },
    async selectAdminList() {
      let that = this
      let m=localStorage.getItem("msgKey")
      if(m.indexOf("_")!=-1){
        let mArray=m.split("_")
        loading("加载中")
        axiosGet(DO_NET_URL + "user/SelectMsgList?from=" + mArray[0] + "&to="+mArray[1]+"&page=" + this.page + "&num=" + this.num, function (res) {
          res.data=JSON.parse(res.data)
          console.log(res.data)
          closeLoading()
          that.adminList = res.data.list
          that.count = res.data.count
          let page = parseInt(res.data.count / that.num)
          if (res.data.count % that.num > 0) {
            page += 1
          }
          that.countPage = page
        })
      }else{
        loading("加载中")
        axiosGet(DO_NET_URL + "user/SelectMsgList?from=" + m + "&to=&page=" + this.page + "&num=" + this.num, function (res) {
          res.data=JSON.parse(res.data)
          console.log(res.data)
          closeLoading()
          that.adminList = res.data.list
          that.count = res.data.count
          let page = parseInt(res.data.count / that.num)
          if (res.data.count % that.num > 0) {
            page += 1
          }
          that.countPage = page
        })
      }

    },
  }
}
</script>

<style scoped>
.text1 {
  border: 1px solid #dcdfe6;
  font-size: 12px;
  border-radius: 2px;
  outline: none;
  padding: 3px 10px;
}

.boxText {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 35px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 50%;
}

.leftTd {
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: 700;
}

.addBtn {
  color: #1890ff;
  background: #e8f4ff;
  border: 1px solid #1890ff;
  cursor: pointer;
  float: left;
  font-size: 12px;
  padding: 7px 15px;
  border-radius: 3px;
}

.th {
  border-bottom: 1px solid #dfe6ec;
  text-align: left;
  padding: 0 10px;
  word-break: break-word;
  background-color: #f8f8f9;
  color: #515a6e;
  height: 40px;
  font-size: 12px;
}

.td {
  border-bottom: 1px solid #dfe6ec;
  padding: 0px 10px;
  min-width: 100px;
  width: auto;
  word-break: break-word;
  background-color: #ffffff;
  color: #606266;
  height: 40px;
  font-size: 12px;
}
</style>